<template>
  <section class="task-filter-card">
    <div class="task-filter-heading">
      <div class="filter-title-group">
        <span class="filter-icon-badge">
          <SlidersHorizontal :size="14" />
        </span>
        <div class="filter-title-texts">
          <h2>任务检索</h2>
          <p>按订单号、客户、店铺及设计状态精准筛选定位</p>
        </div>
      </div>
      <div class="task-filter-actions">
        <button type="button" class="btn-filter-reset" @click="$emit('reset')">
          <RotateCcw :size="13" />
          <span>重置</span>
        </button>
        <button type="button" class="btn-filter-search" @click="$emit('search')">
          <Search :size="14" />
          <span>查询任务</span>
        </button>
      </div>
    </div>

    <div class="task-filter-grid" @keydown.enter.prevent="$emit('search')">
      <div class="filter-field">
        <label class="field-label">订单编号</label>
        <div class="field-input-wrapper">
          <input
            :value="modelValue.orderNo"
            placeholder="输入订单编号"
            @input="update('orderNo', $event.target.value)"
          />
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">客户名称</label>
        <div class="field-input-wrapper">
          <input
            :value="modelValue.customerName"
            placeholder="输入客户名称"
            @input="update('customerName', $event.target.value)"
          />
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">阿里旺旺</label>
        <div class="field-input-wrapper">
          <input
            :value="modelValue.customerWw"
            placeholder="输入旺旺号"
            @input="update('customerWw', $event.target.value)"
          />
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">手机号</label>
        <div class="field-input-wrapper">
          <input
            :value="modelValue.customerPhone"
            placeholder="输入手机号"
            @input="update('customerPhone', $event.target.value)"
          />
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">文件名称</label>
        <div class="field-input-wrapper">
          <input
            :value="modelValue.filename"
            placeholder="输入文件名称"
            @input="update('filename', $event.target.value)"
          />
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">关联店铺</label>
        <div class="field-select-wrapper">
          <select :value="modelValue.shopName" @change="update('shopName', $event.target.value)">
            <option value="">全部店铺</option>
            <option v-for="store in stores" :key="store.id" :value="store.name">{{ store.name }}</option>
          </select>
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">产品类型</label>
        <div class="field-select-wrapper">
          <select :value="modelValue.productType" @change="update('productType', $event.target.value)">
            <option value="">全部类型</option>
            <option value="1">袋子</option>
            <option value="2">吊牌系</option>
          </select>
        </div>
      </div>

      <div class="filter-field">
        <label class="field-label">设计状态</label>
        <div class="field-select-wrapper">
          <select :value="modelValue.designStatus" @change="update('designStatus', $event.target.value)">
            <option value="">全部状态</option>
            <option v-for="item in statusOptions" :key="item.status" :value="item.status">{{ item.label }}</option>
          </select>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { SlidersHorizontal, Search, RotateCcw } from '@lucide/vue';
import { designerTaskStatusMeta } from '@/services/designerTaskService';

const props = defineProps({
  modelValue: { type: Object, required: true },
  stores: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue', 'search', 'reset']);
const statusOptions = Object.entries(designerTaskStatusMeta)
  .filter(([status]) => status !== 'PENDING_ASSIGNMENT')
  .map(([status, meta]) => ({ status, label: meta.label }));

function update(key, value) {
  emit('update:modelValue', { ...props.modelValue, [key]: value });
}
</script>
